import { getTableConfigs } from './schemaCache';

export default {
  methods: {
    async generateColumnMetaData(vueType, table) {

      let defaultColSort = [];

      let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
       headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/schema/hotConfig?table_name=${this.table}`;

      const [hotConfigResponse, tableConfigs] = await Promise.all([
        fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
          method: "GET",
          headers: headers,
          credentials: 'include'
        }),
        getTableConfigs([`${this.table}_view`, this.table])
      ]);

      if ( hotConfigResponse.status == 403 ) {
        let response = await hotConfigResponse.json();
        alert(response.message);
        window.location.href = '/login';
      } else {
        let tableConfig = await hotConfigResponse.json();
        const tables = JSON.parse(localStorage.getItem('tables'));
        const currentTable = tables.find(t => t.name === this.table);
        // determine whether this user has read-only access to this table
        const readOnlyTable = currentTable && currentTable.permissions.length === 1 && currentTable.permissions.includes('SELECT');
        const fieldInfo = tableConfigs[`${this.table}_view`];
        const requiredFields = tableConfigs[this.table];
         
        tableConfig.message[0].json_build_object.fields.forEach(field => {
          let dataPathForNestedJSON = field.path[0].split("data.")[1];
          if (!
            (vueType === "Add" && (field.read_only === true || field.workflow_actions || field.workflow_updates))
            || field.renderer == 'nullAwareCheckbox'
            || field.column_name === "ID"
            || field.column_name === 'Page Results'
            || table.includes('workflow')
          ) {
            let columnObject = {
              title: field.column_name,
              description: field.column_description,
              readOnly: field.read_only || readOnlyTable,
              data: dataPathForNestedJSON,
              renderer: field.renderer === null ? 'text' : field.renderer,
              editor: field.renderer=='filenameRenderer' ? 'file' : 'text',
              relatedTable: field.related_table,
              colToUpdate: field.col_to_update,
              colToRender: field.col_to_render,
              relatedTableColsToShow: field.columns_to_show,
              allow_multiple_values: field.allow_multiple_values_from_foreign_table,
              width: field.col_width,
              colRenderAlias: field.col_render_alias,
              workflowUpdates: field.workflow_updates,
              workflowActions: field.workflow_actions,
              default_value: field.default_value
            };

            // we want to be able to sort the greenhouse results.  we want to sort only the page results field.  So the other fields will be made not sortable
            // those fields are ID and Candidate
            if (table.includes('greenhouse')) {
              if (field.column_name === 'ID' || field.column_name === 'Candidate' || field.column_name === 'Page Templates') {
                columnObject.columnSorting= {
                  indicator: false,
                  headerAction: false,
                  compareFunctionFactory(sortOrder, columnMeta) {
                    return (value, nextValue) => 0; // Don't sort the column.
                  }
                }
              } else {
                if (field.colmn_name === 'Page Results') {
                  columnObject.columnSorting= {
                    sortEmptyCells: false
                  }
                }
              }
            }
            // the editor property should not exist on the columnObject _unless_ a specific custom editor
            // has been configured for the column
            if ( field.editor ) {
              columnObject.editor = field.editor;
              if ( columnObject.editor == 'wysiwyg' || columnObject.editor == 'wysiwygNoHtml' ) {
                columnObject.renderer = 'wysiwygRenderer';
              }
            }

            // Second use the schema to add dropdown values for enums:
            if (fieldInfo) {
              fieldInfo.fields.forEach(field => {
                if (columnObject.data === field.field_name) {
                  columnObject["dataType"] = field.type;
                  if (field.type.includes("USER-DEFINED")) {
                    columnObject['editor'] = 'dropdown'
                    columnObject["source"] = [''];
                    columnObject["type"] = "dropdown";
                    columnObject['renderer'] = "dropdown";
                    JSON.parse(field.type.split("USER-DEFINED")[1]).forEach(val => {
                      columnObject["source"].push(val);
                    });
                  }
                }
              });
            }

            // Third use the schema for the table to indicate required fields.
            if (requiredFields) {
              requiredFields.fields.forEach(rfield => {
                if ((columnObject.data === rfield.field_name || columnObject.colToUpdate === rfield.field_name ) && rfield.field_name !== 'id' && rfield.is_nullable === "NO") {
                  columnObject.title = `${columnObject.title} **`
                }
              });
            }
            if(field.allow_multiple_values_from_foreign_table) {
              columnObject["dataType"] = "ARRAY";
            }
            if (columnObject["dataType"]==="boolean") {
              columnObject["type"] = "checkbox";
            }
            if (currentTable && (currentTable.name.includes('ul_offices_creation_workflow') || currentTable.name.includes('ul_office_matching')) && columnObject.data.includes(".id")) {
              columnObject["type"] = "numeric"
            }

            defaultColSort.push(columnObject);
          }
        });

        // After col meta data is created, we check local storage to get the User's custom column order
        let sorted;
        if (vueType === 'Edit') {
          sorted = JSON.parse(localStorage.getItem(table));
        } else {
          sorted = JSON.parse(localStorage.getItem(`${table}-add`));
        }

        if(sorted) {
          for(let i = 0; i < sorted.length; i++) {
            defaultColSort.map((col) => {
              if(col.title === sorted[i]) {
                this.columnMetaData.push(col);
              }
            })
          }
        } else {
          defaultColSort.map((col) => { // If col ordering hasn't changed, use default from Views
            this.columnMetaData.push(col);
          });
        }
        
        //Append promote to gold for ultralocal
        if (currentTable && vueType === 'Edit'  && currentTable.name.includes('ultralocal.ul_bfed_promote_to_gold_workflow')) {
          this.columnMetaData.push({
            title: "Promote to Gold",
            description: "Check to promote contest to gold",
            readOnly: false,
            data: "promoteselected",
            type: "checkbox",
            renderer: 'promoteToGoldRenderer',
            colWidths: 65
          });
        }
        if (currentTable && vueType === 'Edit'  && currentTable.name.includes('ultralocal.ul_bfed_page_creation_workflow')) {
          this.columnMetaData.push({
            title: "Create Page",
            description: "Check to create profile page",
            readOnly: false,
            data: "promoteselected",
            type: "checkbox",
            renderer: 'promoteToGoldRenderer',
            colWidths: 65
          });
        }

        //Append the delete checkbox if the user has delete permissions
        if (currentTable && vueType === 'Edit' && currentTable.permissions.includes('DELETE') && !currentTable.name.includes('ultralocal.ul_office' )
          && !currentTable.name.includes('ultralocal.ul_bfed_promote_to_gold') && !currentTable.name.includes('ultralocal.ul_bfed_page_creation_workflow')) {
          this.columnMetaData.push({
            title: "Select",
            description: "Check to delete record",
            readOnly: false,
            data: "columnselected",
            type: "checkbox",
            colWidths: 65
          });
        }
        // Check for previously saved # of frozen columns
        if(vueType === 'Edit') {
          let frozenCols = JSON.parse(localStorage.getItem(`${this.table}-save-frozen-cols`));
          if( frozenCols && frozenCols > 0 ) {
            this.leftColsFixed = frozenCols;
          }
        }

      }
    }
  }
};
